export default __webpack_public_path__ + "static/media/38_mobile.76ef8ade.jpeg";